'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _blobStream = require('blob-stream');

var _blobStream2 = _interopRequireDefault(_blobStream);

var _pdfkit = require('pdfkit');

var _pdfkit2 = _interopRequireDefault(_pdfkit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var LOGO_URI = 'https://s3.amazonaws.com/cdn.ifeis.net/images/logo-for-printouts.png';
var STAR_URI = 'https://s3.amazonaws.com/cdn.ifeis.net/images/yellow_star.png';
var TASKS_URI = 'https://s3.amazonaws.com/cdn.ifeis.net/images/blue_tasks.png';

var fPrint = function () {
  function fPrint($q, $window) {
    _classCallCheck(this, fPrint);

    this._ = { $q: $q, $window: $window };
    this.Pdf = _pdfkit2.default;
    this.letter = {
      width: 792,
      height: 612
    };
  }

  _createClass(fPrint, [{
    key: 'create',
    value: function create(filename) {
      var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var _metrics = this.metrics(),
          margin = _metrics.margin;

      var config = {
        margin: margin
      };

      var doc = new this.Pdf(angular.extend(config, props));
      doc.$$stream = doc.pipe((0, _blobStream2.default)());
      doc.$$filename = filename || 'report.pdf';

      return doc;
    }
  }, {
    key: 'download',
    value: function download(doc) {
      return this._.$q(function (resolve, reject) {
        doc.end();

        doc.$$stream.on('finish', function () {
          var url = doc.$$stream.toBlobURL('application/pdf');
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.download = doc.$$filename;
          a.href = url;
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          resolve();
        });
      });
    }
  }, {
    key: 'detectPopupBlocker',
    value: function detectPopupBlocker(doc) {
      var _this = this;

      return this._.$q(function (resolve, reject) {
        var win = _this._.$window.open("about:blank", "", "height=100, width=100");

        if (!win) {
          return reject();
        }

        win.close();
        return resolve();
      });
    }
  }, {
    key: 'metrics',
    value: function metrics() {
      var landscape = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var metrics = {
        margin: 35,
        pageWidth: landscape ? this.letter.width : this.letter.height,
        pageHeight: landscape ? this.letter.height : this.letter.width
      };

      metrics.useablePageWidth = metrics.pageWidth - metrics.margin * 2;
      metrics.useablePageHeight = metrics.pageHeight - metrics.margin * 2;

      return metrics;
    }
  }, {
    key: 'imgSrcToDataUrl',
    value: function imgSrcToDataUrl(src, callback, outputFormat) {
      var img = new Image();
      img.crossOrigin = 'Anonymous';
      img.src = src;

      if (img.complete || img.complete === undefined) {
        img.src = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==";
        img.src = src;
      }

      img.onload = function () {
        var canvas = document.createElement('CANVAS'),
            ctx = canvas.getContext('2d'),
            dataURL = void 0;
        canvas.height = this.height;
        canvas.width = this.width;
        ctx.drawImage(this, 0, 0);
        dataURL = canvas.toDataURL(outputFormat);

        callback(dataURL);
      };
    }
  }, {
    key: 'getImage',
    value: function getImage(uri, urlName) {
      var _this2 = this;

      return this._.$q(function (res) {

        return _this2.imgSrcToDataUrl(uri, function (base64Img) {
          _this2[urlName] = base64Img;

          res(_this2[urlName]);
        });
      });
    }
  }, {
    key: 'getLogo',
    value: function getLogo() {
      var _this3 = this;

      if (this._logoUrl) {
        return this._.$q(function (res) {
          return res(_this3._logoUrl);
        });
      }

      return this.getImage(LOGO_URI, "_logoUrl");
    }
  }, {
    key: 'getStarIcon',
    value: function getStarIcon() {
      var _this4 = this;

      if (this._starUrl) {
        return this._.$q(function (res) {
          return res(_this4._starUrl);
        });
      }

      return this.getImage(STAR_URI, "_starUrl");
    }
  }, {
    key: 'getTasksIcon',
    value: function getTasksIcon() {
      var _this5 = this;

      if (this._tasksUrl) {
        return this._.$q(function (res) {
          return res(_this5._tasksUrl);
        });
      }

      return this.getImage(TASKS_URI, "_tasksUrl");
    }
  }]);

  return fPrint;
}();

exports.default = angular.module('ifeis.printing', []).service('fPrint', fPrint);


//////////////////
// WEBPACK FOOTER
// ./print/index.js
// module id = 83
// module chunks = 0